export default "__VITE_ASSET__C$LhNXQQ__"